module.exports = __webpack_public_path__ + "img/background12.e4fbc695.webp";